// UI feature flags (carta / frontend)
// Si en algún momento quieres volver a mostrar precios, cambia a true.
export const SHOW_MENU_PRICES = false;

// Mostrar acciones de pedido (cantidad + botón Agregar / pago)
export const SHOW_MENU_ORDERING = false;


